import { LitElement, html, css } from 'lit';
class SynapseSpinner extends LitElement {
    static get styles() {
        return css `
      :host {
        --spinnerColor: var(--icon-color-brand-default);
        --spinnerSize: 50px;
        --spinnerSpeed: 1.4s;
      }

      :host([secondary]) {
        --spinnerColor: var(--icon-color-disabled);
      }

      :host([center]) {
        position: absolute;
        margin: 0;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      svg {
        width: var(--spinnerSize);
        max-width: 100px;
        animation: calc(var(--spinnerSpeed) + 400ms) linear infinite svg--animation;
      }

      circle {
        fill: transparent;
        stroke: var(--spinnerColor);
        stroke-width: 10;
        stroke-linecap: round;
        stroke-dasharray: 283;
        stroke-dashoffset: 280;
        transform-origin: 50% 50%;
        animation: var(--spinnerSpeed) ease-in-out infinite both circle--animation;
      }

      @keyframes circle--animation {
        0%,
        25% {
          stroke-dashoffset: 280;
          transform: rotate(0);
        }

        50%,
        75% {
          stroke-dashoffset: 75;
          transform: rotate(45deg);
        }

        100% {
          stroke-dashoffset: 280;
          transform: rotate(360deg);
        }
      }

      @keyframes svg--animation {
        to {
          transform: rotate(360deg);
        }
      }
    `;
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return html `
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="45" />
      </svg>
    `;
    }
}
customElements.define('synapse-spinner', SynapseSpinner);
